module.exports = __webpack_public_path__ + "06_face.27b5b3f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/06_face.png
// module id = ItZ5
// module chunks = 0